import Vue from "vue";
import Vuex from "vuex";
import { getField, updateField } from "vuex-map-fields";
import axios from "axios";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [],
  state: {
    viewContent: {
      submissions: [],
      submissionTags: [],
    },
    config: {
      baseUrl: "",
    },
    submissions: {
      currentPage: 1,
      perPage: 15,
      totalPages: 0,
      totalResults: 0,
      selectedSubmissionsSort: { label: "newest first", value: "date-desc" },
      selectedSubmissionsTags: [],
    },
    searchApp: {
      state: {
        hasSearched: false,
        loading: false,
      },
      searchSubmission: {
        category: "all",
        sort: "dateDesc",
        searchText: "",
        start: 0,
      },
      searchOptions: {
        categoryList: [],
      },
      searchResult: {
        totalResults: 0,
        currentPage: 0,
        totalPages: 0,
        nextStart: null,
        prevStart: null,
        results: [],
        searchTerm: "",
      },
    },
  },
  getters: {
    getField,
    getFilteredSubmissions(state) {
      let filteredSubmissions = state.viewContent.submissions;

      if (state.submissions.selectedSubmissionsSort.value === "date-asc") {
        filteredSubmissions = filteredSubmissions.sort(function (a, b) {
          return new Date(a.date) - new Date(b.date);
        });
      }

      if (state.submissions.selectedSubmissionsSort.value === "date-desc") {
        filteredSubmissions = filteredSubmissions.sort(function (a, b) {
          return new Date(b.date) - new Date(a.date);
        });
      }

      if (state.submissions.selectedSubmissionsTags.length > 0) {
        filteredSubmissions = state.viewContent.submissions.filter(function (
          submission
        ) {
          return submission.tags.some(function (tag) {
            return state.submissions.selectedSubmissionsTags.some(function (
              selectedTag
            ) {
              return tag.id === selectedTag;
            });
          });
        });
      }

      // save number of results
      state.submissions.totalResults = filteredSubmissions.length;

      let totalPages = Math.ceil(
        filteredSubmissions.length / state.submissions.perPage
      );
      state.submissions.totalPages = totalPages;

      // Show perPage projects starting at the currentPage
      let start =
        state.submissions.currentPage * state.submissions.perPage -
        state.submissions.perPage;
      let end = start + state.submissions.perPage;

      // Finally, return the filtered projects
      return filteredSubmissions.slice(start, end);
    },
  },
  mutations: {
    updateField,
    resetSubmissionsPagination: (state) => {
      state.submissions.currentPage = 1;
    },
    resetSubmissionsFiltering: (state) => {
      state.submissions.currentPage = 1;
      state.submissions.selectedSubmissionsSort = {
        label: "newest first",
        value: "date-desc",
      };
      state.submissions.selectedSubmissionsTags = [];
    },
    resetSearchFilterFields: (state) => {
      state.searchApp.searchSubmission.category = "all";
      state.searchApp.searchSubmission.sort = "dateDesc";
      state.searchApp.searchSubmission.searchText = "";
    },
  },
  actions: {
    async submitSearch({ state, commit }) {
      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);

      const paramNames = ["category", "sort", "searchText"];

      for (const paramName of paramNames) {
        params.set(paramName, state.searchApp.searchSubmission[paramName]);
      }

      //todo make sure to parse quotes and other special characters
      url.search = params.toString();
      let newUrl = url.toString();
      window.history.pushState({ path: newUrl }, "", newUrl);

      commit("updateField", {
        path: "searchApp.state.loading",
        value: true,
      });

      // window scroll to top
      window.scrollTo(0, 0);

      const currentUrl =
        window.location.origin + window.location.pathname.replace(/\/$/, "");
      const searchUrl = `${currentUrl}/search`;
      return await axios
        .post(searchUrl, state.searchApp.searchSubmission)
        .then((response) => {
          console.log(response);

          if (response.data) {
            commit("updateField", {
              path: "searchApp.searchResult",
              value: response.data,
            });
            commit("updateField", {
              path: "searchApp.searchResult.searchTerm",
              value: state.searchApp.searchSubmission.searchText,
            });
          }

          commit("updateField", {
            path: "searchApp.state.loading",
            value: false,
          });
          commit("updateField", {
            path: "searchApp.state.hasSearched",
            value: true,
          });
        })
        .catch((error) => {
          console.log(error);
          commit("updateField", {
            path: "searchApp.state.loading",
            value: false,
          });
          commit("updateField", {
            path: "searchApp.state.hasSearched",
            value: true,
          });
        });
    },
  },
});
